import React from 'react';
import { Spin } from 'antd';

export default () => (
    <div className='spinner'>
        <Spin size='large' />
    </div>
);
